import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: 'Nowe zamówienie {{method}}!',
        scheduled: 'Zaplanowane zamówienie {{method}}!',
      },
      labels: {
        today: 'dzisiaj',
        time_remaining_to_accept: 'pozostało na akceptację',
      },
      time_tag: {
        asap: '🕓 Odbiór za {{time}}',
        scheduled: '🕓 Odbiór {{day}} o {{time}}',
      },
      time_tag_estimated: {
        asap: '🕓 Szacowany czas odbioru: {{time}}',
        scheduled: '🕓 Szacowany czas odbioru: {{day}} o {{time}}',
      },
      buttons: {
        confirm_order: 'Potwierdź zamówienie',
        cancel_order: 'Anuluj zamówienie',
      },
      feedback: {
        rough_estimate_warning:
          'To tylko przybliżony szacunek. Rzeczywisty czas przygotowania otrzymasz po przydzieleniu kierowcy i potwierdzeniu czasu dostawy. W tym momencie bilet zostanie wydrukowany automatycznie.',
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Czas przygotowania',
      labels: {
        today: 'Dzisiaj',
        order_time: {
          delivery: {
            asap: 'Dostawa za',
            scheduled: 'Dostawa w dniu',
          },
          other: {
            asap: 'Odbiór za',
            scheduled: 'Odbiór w dniu',
          },
        },
        can_you_make_it: 'Czy dasz radę?',
        we_also_send_this_update_to_the_customer: 'Wysyłamy tę aktualizację również do klienta',
      },
      buttons: {
        yes_lets_go: 'Tak, do dzieła!',
        no_change_time: 'Nie, zmień czas',
        confirm: 'Potwierdź',
      },
      toasts: {
        order_confirmed: {
          title: 'Zamówienie #{{number}} potwierdzone',
          body: 'Jeszcze nie przygotowuj! Powiadomimy Cię, gdy zostanie przydzielony kierowca.',
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          'Niestety dostawa musi zostać anulowana, ponieważ kierowca nie jest dostępny. Kliknij trzy kropki w prawym górnym rogu, aby anulować zamówienie i zwrócić pieniądze klientowi.',
        [BackendErrorCode.DeliveryProviderException]:
          'Niestety dostawa musi zostać anulowana, ponieważ kierowca nie jest dostępny. Kliknij trzy kropki w prawym górnym rogu, aby anulować zamówienie i zwrócić pieniądze klientowi.',
      },
    },
  },
};
